const DODO_STATUS_TYPE = {
    active: "active",
    failed : "failed",
    on_hold: "on_hold",
    pending: "pending",
    paused: "paused",
    cancelled: "cancelled",
    expired: "expired",
    processing: "processing",
    trial: "trial",
    trial_expired: "trial_expired"
}

export default DODO_STATUS_TYPE;
